import ModalGeneric from "./ModalGeneric";

// modal to show that user needs to install metamask
export default function ModalError({title, message, description, callback}) {
	return (
        <ModalGeneric title={title || "Error"} callback={callback} className="border-t-red-600">
            <div className="mt-4 border border-black border-b-0 shadow text-left">
                <div className="p-6 border-b border-black flex items-center">
                    <p className="font-bold text-xl">{message || "An unknown error occurred"}</p>
                </div>
                {description && (<div className="p-4 border-b border-black bg-lightGray">
                    <p className="text-gray-500 overflow-y-auto overflow-x-hidden whitespace-pre-line text-ellipsis">{description}</p>
                </div>)}
            </div>
        </ModalGeneric>
	);
}
